import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-text-icon',
  templateUrl: './text-icon.component.html',
  styleUrl: './text-icon.component.scss'
})
export class TextIconComponent {
  @Input() icon: string;
  @Input() class: string;
  @Input() text: string;
}
